import * as React from "react"
import { Flex } from "@chakra-ui/react"

interface ConnectorMessageProps {
  isReply?: boolean
  isReplyMessage?: boolean
  borderColor: string
  isMobile: boolean
  isTransparent?: boolean
  isApproved: boolean
}

const _ConnectorMessage: React.FC<ConnectorMessageProps> = ({
  isReplyMessage,
  isReply,
  borderColor,
  isMobile,
  isTransparent,
  isApproved
}) => {
  return (
    <Flex
      marginLeft={isReplyMessage ? "1rem" : "auto"}
      fontSize="sm"
      height={
        isMobile && isReplyMessage
          ? "0.5rem"
          : isReplyMessage
          ? "0.7rem"
          : "unset"
      }
      borderLeft={
        isTransparent
          ? "0px"
          : `2px ${isApproved ? "solid" : "dotted"} ${borderColor}`
      }
    ></Flex>
  )
}

export const ConnectorMessage = React.memo(_ConnectorMessage)
